import React from "react";

const CodeTabs = ({ handleTabChange, currentTab }) => {
    return (
        <div
            className="flex space-x-4 relative top-0 playground-tabs ml-2"
        >
            <button
                className={`px-5 py-1 my-2 transition-all focus:outline-none ${
                    currentTab === "html" ? "text-emerald-600 font-bold bg-neutral-800 rounded-md" : ""
                }`}
                onClick={() => handleTabChange("html")}
            >
                HTML
            </button>
            <button
                className={`px-5 py-1 my-2 transition-all focus:outline-none ${
                    currentTab === "css" ? "text-emerald-600 font-bold bg-neutral-800 rounded-md" : ""
                }`}
                onClick={() => handleTabChange("css")}
            >
                CSS
            </button>
            <button
                className={`px-5 py-1 my-2 transition-all focus:outline-none ${
                    currentTab === "javascript" ? "text-emerald-600 font-bold bg-neutral-800 rounded-md" : ""
                }`}
                onClick={() => handleTabChange("javascript")}
            >
                JavaScript
            </button>
        </div>
    );
};

export default CodeTabs;
